import { render, staticRenderFns } from "./testReport.vue?vue&type=template&id=1a4c1956&scoped=true&"
import script from "./testReport.vue?vue&type=script&lang=js&"
export * from "./testReport.vue?vue&type=script&lang=js&"
import style0 from "./testReport.vue?vue&type=style&index=0&id=1a4c1956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4c1956",
  null
  
)

export default component.exports